import { render, staticRenderFns } from "./rascunhos.vue?vue&type=template&id=4bfe0392&scoped=true&"
import script from "./rascunhos.vue?vue&type=script&lang=js&"
export * from "./rascunhos.vue?vue&type=script&lang=js&"
import style0 from "./rascunhos.vue?vue&type=style&index=0&id=4bfe0392&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfe0392",
  null
  
)

export default component.exports